export const ORDERFUL_210 = '210_MOTOR_CARRIER_FREIGHT_DETAILS_AND_INVOICE';

export const hasSubmitted210 = (entity) => {
    const outbound = entity?.outbound_integrations || [];
    return outbound.length > 0;
};

export const hasSuccessful210 = (entity) => {
    const outbound = entity?.outbound_integrations || [];
    return outbound.length > 0 && outbound[0]?.status === 'SUBMITTED';
};

export const countOrdersMissing210 = (invoice, orders) => {
    if (hasSubmitted210(invoice)) return 0;

    const missing = new Set();
    (orders || []).forEach((order) => {
        if (order && hasSubmitted210(order) && !hasSuccessful210(order)) {
            missing.add(order.order_id);
        }
    });

    return missing.size;
};

export const countOrdersRemaining210 = (invoice, orders) => {
    if (hasSubmitted210(invoice)) return 0;

    const missing = new Set();
    (orders || []).forEach((order) => {
        if (order && !hasSuccessful210(order)) {
            missing.add(order.order_id);
        }
    });

    return missing.size;
};

export const hasAnySubmitted210 = (invoice, orders) => {
    return hasSubmitted210(invoice) || (orders || []).some((order) => hasSubmitted210(order));
};

export const allSuccessful210 = (invoice, orders) =>
    hasSuccessful210(invoice) || (orders || []).every((order) => hasSuccessful210(order));
